import { useQuery } from "@tanstack/react-query";
import { listBookingRequests } from "@/api/booking-requests.api";
import { usePermissions } from "@/hooks/use-permissions";

export const bookingRequestKeys = {
  all: ["booking-requests"] as const,
  pendingCount: ["booking-requests", "pending-count"] as const,
};

/** Poll pending booking requests count for sidebar badge and schedule toolbar. */
export function usePendingBookingRequestsCount(): number {
  // Roles without online booking (e.g. PRP counselors) would only get 403s.
  const { can } = usePermissions();
  const { data } = useQuery({
    queryKey: bookingRequestKeys.pendingCount,
    queryFn: () => listBookingRequests("pending"),
    enabled: can("public_booking_requests", "list"),
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });
  return data?.length ?? 0;
}
